import { Outlet } from 'react-router-dom'

import { PageHeader } from '@/components/shared/navigation/PageHeader'

export default function Component({ isSale }: { isSale: boolean }) {
  const items = []
  if (isSale) {
    items.push({ title: 'Detalhes', path: 'detalhes' })
    items.push({ title: 'Itens', path: 'itens' })
  } else {
    items.push({ title: 'Detalhes', path: 'detalhes' })
    items.push({ title: 'Técnico', path: 'tecnico' })
    items.push({ title: 'Itens', path: 'itens' })
  }

  return (
    <>
      <PageHeader
        title={isSale ? 'Ordens de venda' : 'Ordens de serviço'}
        items={items}
        canReturn
      />
      <Outlet />
    </>
  )
}
